import { Match } from '@repo/types';

export type Tournament = {
  id: string;
  name: string;
  matches: Match[];
};

export const ClubNameType = {
  ThreeLetterName: 'threeLetterName',
  ShortName: 'shortName',
  FullName: 'fullName',
  NickName: 'nickName',
} as const;
export type ClubNameType = (typeof ClubNameType)[keyof typeof ClubNameType];

export type TournamentSummaryT = Omit<Tournament, 'matches'>;
